import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-waiting-hours-picker",
  templateUrl: "./waiting-hours-picker.component.html",
  styleUrls: ["./waiting-hours-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WaitingHoursPickerComponent implements OnChanges {
  @Input() limiteHoras = 0;
  @Input() valorHora = 0;
  @Input() selectedHours = 0;
  @Output() horasChanged = new EventEmitter<number>();

  hours: number[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["limiteHoras"]) {
      this.hours = this.buildHourRange(this.limiteHoras);
    }
  }

  selectHour(value: number): void {
    if (value === this.selectedHours) return;
    this.selectedHours = value;
    this.horasChanged.emit(value);
  }

  get subtotal(): number {
    return this.selectedHours > 0 ? this.valorHora * this.selectedHours : 0;
  }

  trackByHour(_: number, value: number): number {
    return value;
  }

  private buildHourRange(limit: number): number[] {
    const safeLimit = Math.max(0, Math.floor(limit));
    if (safeLimit === 0) return [];
    const range: number[] = [];
    for (let i = 1; i <= safeLimit; i++) range.push(i);
    return range;
  }
}
